import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

export function InstallPrompt() {
    const [deferred, setDeferred] = useState(null);
    const [show, setShow] = useState(false);

    useEffect(() => {
        const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
        if (standalone || localStorage.getItem("homiie_install_dismissed")) return;
        const onPrompt = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
        window.addEventListener("beforeinstallprompt", onPrompt);
        return () => window.removeEventListener("beforeinstallprompt", onPrompt);
    }, []);

    const install = async () => {
        if (!deferred) return;
        deferred.prompt();
        await deferred.userChoice;
        setShow(false); setDeferred(null);
    };
    const dismiss = () => { setShow(false); localStorage.setItem("homiie_install_dismissed", "1"); };

    if (!show) return null;
    return (
        <div data-testid="install-prompt" className="fixed inset-x-0 bottom-0 z-[60] mx-auto max-w-md p-3">
            <div className="flex items-center gap-3 rounded-2xl bg-navy p-3 text-white shadow-[0_8px_30px_rgba(16,42,67,0.35)]">
                <img src="/icon-192.png" alt="HOMIIE" className="h-10 w-10 rounded-xl" />
                <div className="min-w-0 flex-1">
                    <p className="font-heading text-sm font-extrabold">Install HOMIIE</p>
                    <p className="truncate text-xs text-white/60">Add to your home screen for one-tap access</p>
                </div>
                <button data-testid="install-app-btn" onClick={install} className="flex shrink-0 items-center gap-1 rounded-full bg-orange px-3.5 py-2 text-xs font-bold text-white active:scale-95"><Download size={14} /> Install</button>
                <button data-testid="install-dismiss-btn" onClick={dismiss} className="shrink-0 rounded-full p-1 text-white/50"><X size={16} /></button>
            </div>
        </div>
    );
}
